<template>
  <div class="HomePage">
    <div style="width: 100%; height: 100%">
      <el-row style="height: 100%">
        <el-col :span="6" class="homeLeft">
          <div class="upBox">
            <div class="leftUp">
              <div class="upAll">
                <div class="title">
                  <i class="iconfont icon-tongji"></i><span>{{ $t("HomPage.comStatistics") }}</span>
                </div>
                <el-row class="upTotal">
                  <el-col :span="4" style="width: 40px">
                    <div class="totalTxt">{{ $t("HomPage.carNum") }}</div>
                  </el-col>
                  <el-col :span="16">
                    <div class="totalNum">
                      <span>{{ carCount }}</span>
                    </div>
                  </el-col>
                  <el-col :span="4">
                    <div class="totalUnit">{{ $t("HomPage.forklift") }}</div>
                  </el-col>
                </el-row>
                <div class="upFlex">
                  <div class="flexHalf">
                    <div class="half">
                      <div class="halfTitle titleOne">{{ onlineCount }}</div>
                      <div class="halfNum">{{ $t("HomPage.onTower") }}<span>({{ $t("HomPage.forklift") }})</span></div>
                    </div>
                    <div class="half">
                      <div class="halfTitle titleTwo">{{ problemCount }}</div>
                      <div class="halfNum">{{ $t("HomPage.failTower") }}<span>({{ $t("HomPage.forklift") }})</span></div>
                    </div>
                  </div>
                  <div class="flexHalf">
                    <div class="half">
                      <div class="halfTitle titleThree">{{ workTimeSum }}</div>
                      <div class="halfNum">{{ $t("HomPage.todayWork") }}<span>({{ $t("HomPage.hour") }})</span></div>
                    </div>
                    <div class="half">
                      <div class="halfTitle titleTwo">{{ alarmCount }}</div>
                      <div class="halfNum">{{ $t("HomPage.violaTower") }}<span>({{ $t("HomPage.forklift") }})</span></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="downBox">
            <div class="leftDown">
              <div class="upAll">
                 <div style="height: 50%">
                    <div class="title">
                      <i class="iconfont icon-weiguichuli"></i
                      ><span>{{ $t("DriverAnalysis.todayVolation") }}</span>
                    </div>
                    <div class="downViolation">
                      <div class="violationHalf">
                        <div class="halfIcon">
                          <i class="iconfont icon-fangpengzhuang-xian"></i>
                          <div class="iconTxt">
                            <div class="txtNum">{{ alarm.collisionCount }}</div>
                            <div class="txtTitle">碰撞(次)</div>
                          </div>
                        </div>
                        <div class="halfIcon">
                          <i class="iconfont icon-chaoshi-regular"></i>
                          <div class="iconTxt">
                            <div class="txtNum">
                              {{ alarm.outPositionCount }}
                            </div>
                            <div class="txtTitle">离位超时(次)</div>
                          </div>
                        </div>
                      </div>
                      <div class="violationHalf">
                        <div class="halfIcon">
                          <i class="iconfont icon-sudu"></i>
                          <div class="iconTxt">
                            <div class="txtNum">{{ alarm.speedOverCount }}</div>
                            <div class="txtTitle">超速(次)</div>
                          </div>
                        </div>
                        <div class="halfIcon">
                          <i class="iconfont icon-dianziweilan-jinru"></i>
                          <div class="iconTxt">
                            <div class="txtNum">
                              {{ alarm.leaveFenceCount }}
                            </div>
                            <div class="txtTitle">离开围栏(次)</div>
                          </div>
                        </div>
                      </div>
                      <div class="violationHalf">
                        <div class="halfIcon">
                          <i class="iconfont icon-canshuiconyouhua-"></i>
                          <div class="iconTxt">
                            <div class="txtNum">{{ alarm.overLoadCount }}</div>
                            <div class="txtTitle">超载(次)</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style="height: 50%">
                    <div class="oneTitle">
                      <i class="iconfont icon-weiguichuli"></i
                      ><span>今日故障</span>
                    </div>
                    <div class="downFault">
                      <div class="fault">
                        <div class="faultNum">
                          {{ problem.FilterPluggingCount }}
                        </div>
                        <div class="faultTxt">空滤堵塞</div>
                      </div>
                      <div class="fault">
                        <div class="faultNum">
                          {{ problem.LowOilPressureCount }}
                        </div>
                        <div class="faultTxt">低油压</div>
                      </div>
                      <div class="fault">
                        <div class="faultNum">{{ problem.LowPowerCount }}</div>
                        <div class="faultTxt">低电压</div>
                      </div>
                      <div class="fault">
                        <div class="faultNum">
                          {{ problem.LowLiquidLevelCount }}
                        </div>
                        <div class="faultTxt">低液位</div>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="12" class="homeCenter">
          <div id="allmap" ref="allmap" style="width: 100%; height: 100%"></div>
        </el-col>
        <el-col :span="6" class="homeRight">
          <div class="rightBox" style="padding: 10px 10px 5px">
            <div class="rightUp">
              <div class="upAll">
                <div class="title">
                  <i class="iconfont icon-paiming"></i
                  ><span>今日车辆工作时长排名(TOP10)</span>
                </div>
                <div style="width: 100%; padding: 10px 0 0">
                  <Table
                    :height="height"
                    :list="list"
                    ref="carTable"
                    :options="option"
                    :columns="columns"
                  ></Table>
                </div>
              </div>
            </div>
          </div>
          <div class="rightBox" style="padding: 5px 10px 10px">
            <div class="rightDown">
              <div class="upAll">
                <div class="title">
                  <i class="iconfont icon-paiming"></i
                  ><span>今日驾驶员工作时长排名(TOP10)</span>
                </div>
                <div style="width: 100%; padding: 10px 0 0">
                  <Table
                    :height="height"
                    :list="driveList"
                    ref="carTable"
                    :options="option"
                    :columns="driveColumns"
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import HomePage from "./HomePage.js";
export default HomePage;
</script>

<style lang="less" scoped>
@import url("./HomePage.less");
</style>
